import { HealthTabShell } from '@/components/health/HealthTabShell';
import { useParams } from 'react-router-dom';

export function TourHealthTab() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return (
    <HealthTabShell
      basePath={`/tours/${id}/health`}
      title="Tour health"
      description="Quality checks scoped to this tour's attractions. Pick a check to see what needs attention."
    />
  );
}
